import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import { IBulkUserInvitationResponse, ICreateUserInvitation, ICreateUserInvitationResponse } from "./types"

export const createUserInvitation = (
    botId: string,
    data: ICreateUserInvitation
): Promise<AxiosResponse<ICreateUserInvitationResponse>> => {
    return apiInstance.handler.post(`/communities/${botId}/user-invitations`, data)
}

export const createUserInvitationsBulk = (
    botId: string,
    file: File
): Promise<AxiosResponse<IBulkUserInvitationResponse>> => {
    const formData = new FormData()
    formData.append('file', file)
    return apiInstance.handler.post(`/communities/${botId}/user-invitations/bulk`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}
